import { NestedSignersModeEnum } from '../enums/NestedSignersModeEnum';

interface IGetNestedSignersModeParams {
  hasActOrResultDecisionFirstExtractDateTime?: boolean;
  isNewActOrResultDecision?: boolean;
}

/**
 * Режим подписантов акта/решения по isNew / firstExtractDateTime / signed.
 */
export const getNestedSignersMode = ({
  hasActOrResultDecisionFirstExtractDateTime,
  isNewActOrResultDecision,
}: IGetNestedSignersModeParams): NestedSignersModeEnum => {
  if (isNewActOrResultDecision) {
    return NestedSignersModeEnum.NEW_SINGLE;
  }

  if (hasActOrResultDecisionFirstExtractDateTime) {
    return NestedSignersModeEnum.MULTI_FIRST_LOCKED;
  }

  return NestedSignersModeEnum.ADD_HIDDEN;
};
